import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const Phone = forwardRef<SVGSVGElement, Partial<IconProps>>(function Phone({
  styles,
  ...props
}, ref) {
  return <Icon styles={styles} viewBox="0 0 24 24" title="Phone" description="Telephone icon" ref={ref} {...props}>
        <path {...stylex.props([iconsStyles.neutralElement])} d="M4.827 10.521c1.92 3.459 5.013 6.282 8.786 8.055l2.934-2.69c.36-.33.893-.44 1.36-.293 1.493.453 3.106.697 4.76.697.733 0 1.333.55 1.333 1.222v4.266C24 22.45 23.4 23 22.667 23 10.147 23 0 13.699 0 2.222 0 1.55.6 1 1.333 1H6c.733 0 1.333.55 1.333 1.222 0 1.528.267 2.995.76 4.364.147.427.04.904-.333 1.246l-2.933 2.69z" />
      </Icon>;
});